import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { streamsRoutes } from './streams.routes';

import {StreamsContentComponent} from './components/streams-content/streams-content.component';
import {StreamsToolbarComponent} from './components/streams-toolbar/streams-toolbar.component';

import { StoreModule } from '@ngrx/store';
import { StreamsService } from './services/streams.service';
import { EffectsModule } from '@ngrx/effects';


import {streamsReducer} from './store/reducers/streams.reducer';
import {StreamsEffects} from './store/effects/streams.effects';
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(streamsRoutes),
    StoreModule.forFeature('streams', streamsReducer),
    EffectsModule.forFeature([StreamsEffects]),
    SharedModule
  ],
  providers: [StreamsService],
  declarations: [
    StreamsContentComponent,
    StreamsToolbarComponent
  ]
})
export class StreamsModule { }
